import EventEmitter from "eventemitter3";

export enum EGlobalEvent {
  StartSceneTransition = "startSceneTransition",
  EndSceneTransition = "endSceneTransition",
  WonLevel = "globalWonLevel",
}

export const GlobalEvents = new EventEmitter();
